/* globals CODE_VERSION */
import Rollbar from 'rollbar';

import { isProduction } from '@kareo/utils';
import LoggableErrors from './loggable-errors';

function getApiToken(isProd) {
  return isProd
    ? '03dd54727bb3449f82da5970778d6ec8'
    : '4f49289c6cc443eb8311e1b092b8109a';
}

function getRollbarEnvironment() {
  if (window.location.hostname === 'app.kareo.com') {
    var pathname = window.location.pathname;
    return pathname.substr(1, pathname.indexOf('/', 1) - 1);
  } else if (window.location.hostname.includes('uiproxy.kareoprod.ent')) {
    return 'uiproxy';
  } else {
    return window.location.hostname;
  }
}

function configureRollbar() {
  try {
    var loggableErrors = new LoggableErrors();

    window.Rollbar = new Rollbar({
      async: false,
      verbose: true,
      accessToken: getApiToken(isProduction()),
      captureUncaught: true,
      // IMPORTANT : this configuration option makes sure all unhandled rejects get sent to rollbar
      captureUnhandledRejections: true,
      checkIgnore: loggableErrors.checkIgnore,
      payload: {
        client: {
          javascript: {
            source_map_enabled: true,
            // global CODE_VERSION comes in during compile
            code_version: !!CODE_VERSION ? CODE_VERSION : 'localhost',
          },
        },
        environment: getRollbarEnvironment(),
      },
      transform: loggableErrors.transformError,
    });
  } catch (ex) {
    console.error('Rollbar Configuration error : ', ex);
  }
  return window.Rollbar;
}

export default configureRollbar();
